import React, { useContext } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import queryString from 'query-string'

import { PageLayout, ProductList, PageBreadcrumb } from '../../components'
import { l } from '../../lib/locale'
import { context } from '../../store'

const Image = ({ data, src, alt, className }) => {
  const file = data.allFile.edges.find(({ node }) => node.childImageSharp.fluid.originalName === src)
  if (file) {
    return <Img className={className} fluid={file.node.childImageSharp.fluid} />
  }
  return ''
}

const MontanaPantonWire26ActionTemplate = ({ data, pageContext }) => {
  const { store } = useContext(context)
  const { lang, page } = pageContext

  let items = null
  if (store && store.app && store.app.cartrules) {
    const rule = store.app.cartrules.find(i => i.display_code && i.display_code.toUpperCase() === "202603PANTONWIRE")
    items = data.allShopProduct.edges.filter(({ node }) => {
      return (rule && rule.items && rule.items.includes(+node.id_product) && +node.active === 1)
    }).map(i => i.node)
  }

  const navigation = {
    page: 0
  }
  if (typeof window !== 'undefined') {
    const qs = queryString.parse(window.location.search)
    navigation.page = qs.page ? +qs.page : 0
  }

  const contentEN = (
    <div className="row mb-5">
      <div className="col-6 px-4">
        <h2 className="mb-5">Panton Wire — A timeless and adaptable system for many purposes</h2>
        <h4 className="mb-5">Save 25% from 28 February — 22 March 2026.</h4>
        <p className="">Designed by Verner Panton in 1971, the Panton Wire has re-emerged as a design collectible with new elements and tops added to the flexible system. Raw yet elegant, light yet industrial, the Panton Wire unit can be used individually or in combination – on the floor, hanging on the wall, stacked or as room dividers.</p>
        <p className="">The Panton Wire is available in 2 depths, 4 finishes, the tops in 9 finishes and shelves in 6 finishes.</p>
      </div>
      <div className="col-6">
        <Image data={data} src="202603pantonwire.1.jpg" className="img-fluid w-100" alt="25% korting op Panton Wire" />
      </div>
    </div>
  )

    const contentNL = (
    <div className="row mb-5">
      <div className="col-6 px-4">
        <h2 className="mb-5">Panton Wire — Een tijdloos en flexibel systeem voor vele doeleinden</h2>
        <h4 className="mb-5">Bespaar 25% van 28 februari tot en met 22 maart 2026.</h4>
        <p className="">Ontworpen door Verner Panton in 1971, is de Panton Wire opnieuw uitgebracht als een gewild designitem, met nieuwe elementen en bladen die aan het flexibele systeem zijn toegevoegd. Ruw maar elegant, licht maar industrieel, de Panton Wire unit kan afzonderlijk of in combinatie worden gebruikt – op de vloer, hangend aan de muur, gestapeld of als ruimteverdeler.</p>
        <p className="">De Panton Wire is verkrijgbaar in 2 diepten, 4 afwerkingen, de bladen in 9 afwerkingen en de planken in 6 afwerkingen.</p>
      </div>
      <div className="col-6">
        <Image data={data} src="202603pantonwire.1.jpg" className="img-fluid w-100" alt="25% korting op Panton Wire" />
      </div>
    </div>
  )

  return (
    <PageLayout lang={lang} switcher={page}>
      <div className="product-list-4 product-list-breadcrumbs">
        <PageBreadcrumb lang={lang} current={page} items={[ 'homepage' ]} />

        {+lang.id_lang === 1 && contentEN}
        {+lang.id_lang === 4 && contentNL}

        <ProductList
          title={page[`title_${lang.suffix}`]}
          products={items}
          attributes={data.allShopAttribute.edges.map(i => i.node)}
          attribute_groups={data.allShopAttributeGroup.edges.map(i => i.node)}
          lang={lang}
          navigation={navigation}
          keyPrefix="202603pantonwire" />
      </div>
    </PageLayout>
  )
}

export default MontanaPantonWire26ActionTemplate

export const query = graphql`
  query MontanaPantonWire26ActionTemplateQuery {
    allFile(filter: {relativeDirectory: {eq: "actions/202603pantonwire"}}) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 700) {
              originalName
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    allShopProduct {
      edges {
        node {
          ...ProductSearchItem
        }
      }
    }
    allShopAttributeGroup {
      edges {
        node {
          group_type
          id_attribute_group
          is_color_group
          name_en
          name_nl
          position
          public_name_en
          public_name_nl
        }
      }
    }
    allShopAttribute {
      edges {
        node {
          id_attribute
          id_attribute_group
          color
          name_en
          name_nl
          position
        }
      }
    }
  }
`
